export const Duration = {
  confirmationTimeout: 3000,
  long: '500ms',
  medium: '250ms',
  short: '100ms',
  tooltipTimeout: {
    default: 1250,
    short: 500,
  },
};
